import { createSlice } from "@reduxjs/toolkit";
import buildAction from "../../helpers/buildAction.ts";
import thunks from "./thunks";
import reducers from "./reducers";
import { IDomainsSlice } from "@/redux/slices/domains/types";

export const initialState: IDomainsSlice = {
  search: {
    loading: false,
    results: {
      available: [],
      unavailable: [],
    },
  },
  bulk: {
    loading: false,
    results: {
      available: [],
      unavailable: [],
    },
  },
};

export const domainsSlice = createSlice({
  name: "numbers",
  initialState,
  reducers,
  extraReducers: (builder) => {
    thunks.forEach((thunk) => buildAction(builder, thunk));
  },
});

export default domainsSlice.reducer;
